import { render, staticRenderFns } from "./edit-account.vue?vue&type=template&id=79a3fa3e&"
import script from "./edit-account.vue?vue&type=script&lang=ts&"
export * from "./edit-account.vue?vue&type=script&lang=ts&"
import style0 from "./edit-account.vue?vue&type=style&index=0&lang=stylus&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports